module.exports = __webpack_public_path__ + "media/images/clients/bang-e9658c9ca4bee68c22fd60b253c26d48.svg";